"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undoLayoutChangesHandler = void 0;
var tslib_1 = require("tslib");
var general_1 = require("../../events/general");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var layout_1 = require("../../store/layout");
var layout_2 = require("../../events/layout");
/*
 * Default impl returns 0 -> meaning drop everything that the latest command achieved.
 */
var latestCommandUndoSelector = function (_cmds) {
    return 0;
};
function undoLayoutChangesHandler(ctx, cmd) {
    var undoableCommands, _a, undoPointSelector, undoUpToIncludingCmd, selectedCommand, layout;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectUndoableLayoutCommands)];
            case 1:
                undoableCommands = _b.sent();
                _a = cmd.payload.undoPointSelector, undoPointSelector = _a === void 0 ? latestCommandUndoSelector : _a;
                undoUpToIncludingCmd = undoPointSelector(undoableCommands.map(function (entry) { return entry.cmd; }));
                if (undoUpToIncludingCmd < 0 || undoUpToIncludingCmd >= undoableCommands.length) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Undo point selector returned result out of bounds. Undoable commands: " + undoableCommands.length + ". Got index: " + undoUpToIncludingCmd);
                }
                selectedCommand = undoableCommands[undoUpToIncludingCmd];
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.undoLayout({
                        undoDownTo: selectedCommand.firstOccurrenceOnStack,
                    }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 3:
                layout = _b.sent();
                return [2 /*return*/, layout_2.layoutChanged(ctx, layout, cmd.correlationId)];
        }
    });
}
exports.undoLayoutChangesHandler = undoLayoutChangesHandler;
//# sourceMappingURL=undoLayoutChangesHandler.js.map